import { render, staticRenderFns } from "./EmailClientButton.vue?vue&type=template&id=1ede1d44"
import script from "./EmailClientButton.vue?vue&type=script&lang=js"
export * from "./EmailClientButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports